import axios from '../_helpers/axios';

export const inventory_historiesService = {
  get_inventory_histories,
};


async function get_inventory_histories(data) {
  return new Promise((resolve, reject) => {
    axios.post('inventory_histories', data)
    .then(resp => {
        if(resp.data && resp.data.data){
          resolve(resp.data.data)
        }
    }).catch(function(error){
      if (error.response && error.response.data && error.response.data.error) {
        reject(error.response.data.error.error_message)
        return
      }
      reject(error)
    })
  })
}
